<template lang="pug">
  .component-backoffice-note-list.row.column
     reservation-rate(v-for="rate in reservation_rates", :item="rate", type="listing")
</template>

<script>
  import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
  import BaseList from "./BaseList";
  import ReservationRate from "../../components/backoffice/ReservationRate";

  export default {
    name: "NoteList",
    components: {ReservationRate, BaseList},
    data() {
      return {
        reservation_rates: [],
        component: require('src/components/backoffice/ReservationRate'),
      }

    },
    created() {
      KeplerBackofficeSdk.reservationRates.list.rates((data) => {
        this.reservation_rates = data.reverse()
      })
    },
    methods: {

    }
  }
</script>

<style scoped lang="sass">
  .component-backoffice-zone-list
    .map
      height: 400px
    .zone-edit
      color: white

</style>



// WEBPACK FOOTER //
// ReservationRateList.vue?52c14108